module.exports = __webpack_public_path__ + "static/media/game_bottom_background.f13361cc.png";